<script>
import formInput from "@/mixins/shared/formInput";

export default {
	mixins: [formInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		'value': {
			required: false
		},
		'checked': {
			type: [Array, Boolean],
			default: false,
		},
	},
	methods: {
		onChange(event) {
			let isChecked = event.target.checked
			if (this.modelValue instanceof Array) {
				let newValue = [...this.modelValue]
				if (isChecked) {
					newValue.push(this.value)
				} else {
					newValue.splice(newValue.indexOf(this.value), 1)
				}
				this.$emit('update:modelValue', newValue);
			} else {
				let result = null;
				if (this.value) {
					if (isChecked) {
						result = this.value;
					}
				} else {
					result = !!isChecked
				}
				this.$emit('update:modelValue', result);
			}
		}
	}
}
</script>

<template>
	<div :class="{
    'form-check': true,
    [groupClasses]: groupClasses,
  }">
		<input
			v-bind="$attrs"
			@change="onChange"
			type="checkbox"
			:checked="checked"
			:name="name"
			:id="renderedId"
			:class="{'form-check-input': true, 'border-danger': hasError}"
			:value="value"
		>
		<label v-if="label" :for="renderedId" :class="{'form-check-label': true, 'text-danger': hasError}">{{ label }}</label>
		<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
	</div>
</template>